<qwyk-breadcrumbs [entityIdValue]="quotation.friendly_id" [url]="url" [app]="'hub'"></qwyk-breadcrumbs>
<div class="border-bottom d-flex py-2 mb-3 align-items-center">
    <div class="flex-grow-1">
        <qwyk-quotation-status-badge
            [filled]="true"
            [status]="quotation.status"
            class="mr-2"></qwyk-quotation-status-badge>
        <span class="text-muted">
            {{ 'common.customer' | translate }}:
            <a (mouseenter)="headerUserPopoverContent.show($event)" (mouseleave)="headerUserPopoverContent.hide()" href="javascript:void(0)">
                <img
                    [src]="'https://www.gravatar.com/avatar/' + (quotation.owner.email | md5) + '?d=https%3A%2F%2Fui-avatars.com%2Fapi%2F/' + (quotation.owner.name | urlEncode) + '/24/097aff/ffffff/2//false/true/true'"
                    class="rounded-circle border"
                    style="width: 20px; height: 20px; margin-top: -4px">
                {{ quotation.owner.name }}
            </a>

            <p-overlayPanel #headerUserPopoverContent>
                <qwyk-user-info-tooltip [user]="quotation.owner"></qwyk-user-info-tooltip>
            </p-overlayPanel>

            {{ 'common.created' | translate }}
            <span [pTooltip]="quotation.request.created_at | amLocal | amDateFormat: 'LLL'"
                class="text-underline-dashed" tooltipPosition="bottom">
                {{ quotation.request.created_at | amLocal | amTimeAgo }}
            </span>
            <ng-container *ngIf="quotation.creator">
                {{ 'common.by' | translate }}
                <a (mouseenter)="ownerUserPopoverContent.show($event)" (mouseleave)="ownerUserPopoverContent.hide()" href="javascript:void(0)">
                    <img
                        [src]="'https://www.gravatar.com/avatar/' + (quotation.creator.email | md5) + '?d=https%3A%2F%2Fui-avatars.com%2Fapi%2F/' + (quotation.creator.name | urlEncode) + '/24/097aff/ffffff/2//false/true/true'"
                        class="rounded-circle border"
                        style="width: 20px; height: 20px; margin-top: -4px">
                    {{ quotation.creator.name }}</a>
                <p-overlayPanel #ownerUserPopoverContent>
                    <qwyk-user-info-tooltip [user]="quotation.creator"></qwyk-user-info-tooltip>
                </p-overlayPanel>
            </ng-container>
        </span>
    </div>

    <div class="d-flex align-items-center">
        <div class="ml-2">
            <div class="btn-group mr-3" role="group">
                <button (click)="publish.emit(quotation)" *ngIf="quotation.is_draft"
                        [disabled]="busy || isPolling"
                        class="btn btn-outline-primary"
                        pTooltip="{{ 'hub.quotations.details.publish-quotation-tooltip' | translate }}">
                    <fa-icon *ngIf="busy" [icon]="['far', 'spinner']" [animation]="$any(iconAnimation)"
                             class="mr-2"></fa-icon>
                    {{ 'hub.quotations.details.publish-quotation' | translate }}
                </button>
                <button (click)="download.emit(quotation)" *ngIf="!quotation.is_draft"
                        [disabled]="busy || isPolling" class="btn btn-outline-primary"
                        pTooltip="{{ 'hub.quotations.details.download-quotation-tooltip' | translate }}">
                    <fa-icon [icon]="['far', !busy ? 'file-download' : 'spinner']" [animation]="$any(iconAnimation)"
                             class="mr-2"></fa-icon>
                    {{ 'common.download' | translate }}
                </button>

                <button class="btn btn-outline-primary dropdown-toggle-split px-3"
                        (click)="dropdownMenu.toggle($event)">
                    <fa-icon [icon]="['far', 'chevron-down']"></fa-icon>
                </button>
            </div>

            <p-overlayPanel #dropdownMenu>
                <ul class="nav flex-column my-2">
                    <li class="nav-item px-3 pl-0 dropdown-item">
                        <a class="p-0 dropdown-item" [attr.disabled]="busy || isPolling" [queryParams]="{'copy': true}"
                            [routerLink]="['..', 'new', quotation.id, 'copy']">
                            <fa-icon [fixedWidth]="true" [icon]="['far', !busy ? 'copy' : 'spinner']" [animation]="$any(iconAnimation)"
                                     class="mr-2"></fa-icon>
                            {{ 'hub.quotations.details.copy-quotation' | translate }}
                        </a>
                    </li>
                    <li class="nav-item px-3 pl-0 dropdown-item" *ngIf="quotation.status === 'open'">
                        <a class="p-0 dropdown-item" (click)="close.emit(quotation)"
                           [attr.disabled]="busy || isPolling" href="javascript:void(0)">
                            <fa-icon [fixedWidth]="true" [icon]="['far', busy ? 'spinner' : 'do-not-enter']"
                                     [animation]="$any(iconAnimation)"
                                     class="mr-2"></fa-icon>
                            {{ 'hub.quotations.details.close-quotation' | translate }}
                        </a>
                    </li>
                    <li class="nav-item dropdown-item px-3 pl-0" *ngIf="quotation.is_draft">
                        <a class="p-0 dropdown-item text-danger" (click)="delete.emit(quotation)"
                           [attr.disabled]="busy || isPolling" href="javascript:void(0)">
                            <fa-icon [fixedWidth]="true" [icon]="['far', busy ? 'spinner' : 'trash']" [animation]="$any(iconAnimation)"
                                     class="mr-2"></fa-icon>
                            {{ 'hub.quotations.details.delete-quotation' | translate }}
                        </a>
                    </li>
                    <ng-container *ngIf="isMasterAdmin">
                        <li class="nav-item">
                            <div class="dropdown-divider"></div>
                        </li>
                        <li class="nav-item dropdown-item px-3 pl-0">
                            <a [queryParams]="{'transactionable_id': quotation.id, 'transactionable_type': 'App\\Models\\Portals\\Quotations\\Quotation'}"
                               [routerLink]="['/console', 'logs', 'connection-transactions']"
                               target="_blank"
                               class="p-0 dropdown-item">
                                <fa-icon [fixedWidth]="true" [icon]="['far', 'list']" class="mr-2"></fa-icon>
                                {{ 'hub.quotations.details.auto-rate-logs' | translate }}
                            </a>
                        </li>
                    </ng-container>
                </ul>
            </p-overlayPanel>
        </div>
    </div>
</div>

<div class="d-flex flex-row justify-content-between mb-3">
    <h3 class="font-weight-normal m-0">
        {{ 'common.quotations.quotation' | translate | titlecase }}
        <span *ngIf="quotation.friendly_id" class="text-muted">
            {{ quotation.friendly_id }}
        </span>
    </h3>
</div>
